export default __webpack_public_path__ + "static/media/tags-1709067000823.d8e7eed8.jpg";